module.exports = __webpack_public_path__ + "static/media/laxmi.f034ca71.jpg";